import React, { useState, useEffect } from 'react';
import { useSnackbar } from 'notistack';
import * as staticsApi from '../../lib/api/statics';
import {
  makeHqSalesStatics,
  salesHeaders,
} from '../../utils/forecastStaticData';
import SalesStaticsHeadquarterTable from '../../components/sales-statics/SalesStaticsHeadquarterTable';

const SalesStaticsHeadquarterContainer = ({
  year,
  startMonth,
  endMonth,
  searchDate,
  tableRef,
}) => {
  const { enqueueSnackbar } = useSnackbar();
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState();

  const onLoadData = async () => {
    setLoading(true);

    try {
      const res = await staticsApi.getHqSalesStatics(
        year,
        startMonth,
        endMonth,
      );

      if (res.data.list) {
        setData(res.data.list);
      }
    } catch (err) {
      let message =
        typeof err.response !== 'undefined'
          ? err.response.data.message
          : err.message;
      enqueueSnackbar(message, {
        variant: 'error',
      });
    }
    setLoading(false);
  };

  useEffect(() => {
    if (searchDate) {
      onLoadData();
    }
  }, [searchDate]);

  return (
    <SalesStaticsHeadquarterTable
      data={data}
      loading={loading}
      headerRows={salesHeaders}
      tableRef={tableRef}
    />
  );
};

export default SalesStaticsHeadquarterContainer;
